module.exports = __webpack_public_path__ + "components/intersport-discount-page/promo-article/static/article-image-fd1e1ec98f57615161fa39eb57600889.jpg";